import { render, staticRenderFns } from "./TransactionsMain.vue?vue&type=template&id=7d79c25f&scoped=true"
import script from "./TransactionsMain.vue?vue&type=script&lang=js"
export * from "./TransactionsMain.vue?vue&type=script&lang=js"
import style0 from "./TransactionsMain.vue?vue&type=style&index=0&id=7d79c25f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d79c25f",
  null
  
)

export default component.exports